import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Deserialize } from "cerialize";
import { Actualite } from "../models/actualite";
import {Contact} from "../models/contact";

@Injectable({
    providedIn: 'root'
})
export class ActualitesService {

    baseApiUrl: string = environment.api.baseUrl;

    protected _actualites: BehaviorSubject<Actualite[]> = new BehaviorSubject(null);
    public readonly actualites: Observable<Actualite[]> = this._actualites.asObservable().pipe(filter(actualites => actualites != null));

    constructor(private http: HttpClient) {
    }

    load(logementId: number): Observable<Actualite[]> {
        return this.http.get(`${this.baseApiUrl}actualites/${logementId}`).pipe(switchMap(data => {
                this._actualites.next(Deserialize(data, Actualite));
                return this.actualites;
            })
        );
    }

    findQualitelActualite(logementId: number, type: string, actualiteId: number): Observable<Actualite>{
      if (this._actualites.value == null) {
        this.load(logementId).toPromise();
      }
      return this.actualites.pipe(map(actualites => actualites.find(actualite => {
        return actualite.type == type && actualite.id == actualiteId;
      })));
    }

    findCarnetActualiteById(type: string, actualiteId: number): Promise<Actualite> {
      return this.http.get(`${this.baseApiUrl}actualite/${actualiteId}`).toPromise().then(
        (data) => {
          return Deserialize(data, Actualite);
        },
        (data) => {
          if (data.status === 400 || data.status === 422) {
            return data.error;
          }
          throw new Error(`An unexpected error occurred while data loading ${JSON.stringify(data)}`);
        });
    }
}
